import Overpurchase from './overpurchase.vue'
export default Overpurchase
